import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { MyListApi } from "../utils/restApi";

export const fetchItems = createAsyncThunk('userItems/fetchItems', async ({ userId, tagName, actionName, page = 0, perPage = 30 }) => {
    const data = await MyListApi.getItems(userId, tagName, null, null, false, page, perPage);
    return data.data;
});

const userItemsSlice = createSlice({
    name: 'userItems',
    initialState: {
        userId: null,
        tagName: null,
        actionName: null,
        items: [],
        page: 0,
        count: 0,
        status: 'idle',
        error: null,
    },
    reducers: {
    },
    extraReducers: (builder) => {
        builder
            .addCase(fetchItems.pending, (state) => {
                state.status = 'pending';
            })
            .addCase(fetchItems.fulfilled, (state, action) => {
                state.status = 'succeeded';
                // state.tag = action.meta.arg.tag;
                state.items = action.payload.items;
                state.count = action.payload.count;
                state.page = action.payload.page;
            })
            .addCase(fetchItems.rejected, (state, action) => {
                state.status = 'rejected';
                state.error = action.error.message;
            });
    }
});

export default userItemsSlice.reducer;